//アコーディオンをクリックした時の動作
//質問エリアをクリック
$(document).on('turbolinks:load', function() {
    $('.bl_faq_q').on('click', function(){
    //classを追加してアイコンを変える
    $(this).toggleClass('is_selected');
    //対象の質問エリアを開閉する
    $(this).next().slideToggle();
    $(this).toggleClass('open',500);
    }
    );
});

//新着情報ページ左メニューをクリックした時のアコーディオンの動作
//左メニュー「上場廃止情報」をクリック
$(document).on('turbolinks:load',function() {
    $('.delisting').on('click', function(){
    //classを追加してアイコンを変える
    $('#delisting').addClass('is_selected');
    //対象の質問エリアを開閉する
    $('#delisting').next().slideDown();
    $('#delisting').addClass('open',500);
    }
    );
});

//左メニュー「株式分割情報」をクリック
$(document).on('turbolinks:load',function() {
    $('.division').on('click', function(){
    //classを追加してアイコンを変える
    $('#division').addClass('is_selected');
    //対象の質問エリアを開閉する
    $('#division').next().slideDown();
    $('#division').addClass('open',500);
    }
    );
});

//左メニュー「社名変更情報」をクリック
$(document).on('turbolinks:load',function() {
    $('.name_change').on('click', function(){
    //classを追加してアイコンを変える
    $('#name_change').addClass('is_selected');
    //対象の質問エリアを開閉する
    $('#name_change').next().slideDown();
    $('#name_change').addClass('open',500);
    }
    );
});

//左メニュー「合併情報」をクリック
$(document).on('turbolinks:load',function() {
    $('.amalgamation').on('click', function(){
    //classを追加してアイコンを変える
    $('#amalgamation').addClass('is_selected');
    //対象の質問エリアを開閉する
    $('#amalgamation').next().slideDown();
    $('#amalgamation').addClass('open',500);
    }
    );
});

//ページ内リンク スムーススクロール
$(document).on('turbolinks:load',function() {
    $('a[href^="#"]').click(function () {
    const speed = 600;
    let href = $(this).attr("href");
    let target = $(href == "#" || href == "" ? "html" : href);
    let position = target.offset().top;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
    });
});
